<template>
  <dsf-exam-layout :exam-loading="examLoading">
    <template #header>
      <el-row type="flex" justify="space-around">
        <el-col :span="8">
          <el-tooltip effect="light" :content="examInfoData.manageName" placement="right">
            <h3 class="name">{{ examInfoData.manageName }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <h3 class="time"></h3>
        </el-col>
        <el-col :span="8">
          <div class="user">
            {{ examInfoData.examUserName }}
            <el-popover popper-class="popper-user-info" placement="bottom-end" trigger="click" @show="shwoUserInfo">
              <dsf-view-part :path="examInfoPath" />
              <i slot="reference" class="iconfont icon-bangzhuzhongxin" title="考试信息"></i>
            </el-popover>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #left>
      <p class="sub-title list bg pd-10">答题卡</p>
      <div class="card-list">
        <el-row class="card-tips pd-10">
          <el-col :span="8" class="a1">已答：{{ answeredCount }}</el-col>
          <el-col :span="8" class="a2">未答：{{ speedLength - answeredCount }}</el-col>
          <el-col :span="8" class="a3">标记：{{ markedCount }}</el-col>
        </el-row>
        <template v-for="data in examInfoData.items">
          <p class="sub-title list pd-10" :key="'lefttitle_' + data.examPaperItemsId" v-if="data.name">
            {{ data.name }}<span class="sub">（共{{ data.totalNum }}题，合计{{ data.totalScore }}分）</span>
          </p>
          <div class="question-list" :key="data.examPaperId + data.examPaperItemsId">
            <template v-for="(q, i) in data.questions">
              <div
                v-if="data.questionsItems.value != 'group'"
                :class="['item', q.answered ? 'answered' : '', q.marked ? 'marked' : '']"
                :key="'list_' + q.examQuestionsId"
                @click="toScroll(q.examQuestionsId)"
              >
                {{ ++i }}
              </div>
              <template v-for="childValue in q.children" v-else>
                <div
                  :class="['item', childValue.answered ? 'answered' : '', childValue.marked ? 'marked' : '']"
                  :key="'group_' + childValue.examQuestionsId"
                  @click="toScroll(childValue.examQuestionsId, childValue.groupIndex - 1)"
                >
                  {{ childValue.groupIndex }}
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
    <template #main>
      <template v-for="(data, index) in examInfoData.items">
        <p class="sub-title list bg pd-20" :key="'subtitle_' + data.examPaperItemsId">
          {{ dsf.math.toChinesNum(++index) + "、" + data.name }}
          <span class="sub" v-if="data.totalScore"> （共{{ data.questions.length }}题，合计{{ data.totalScore }}分） </span>
        </p>
        <div class="exam-content" :key="'content_' + data.examPaperItemsId">
          <div
            v-for="(subjects, examIndex) in data.questions"
            :ref="'question' + subjects.examQuestionsId"
            :key="'question_' + subjects.examQuestionsId"
          >
            <dsf-exam-item-box :subjects="subjects" :exam-index="examIndex" />
          </div>
        </div>
      </template>
    </template>
    <template #right>
      <div class="timer">
        <p class="txt">剩余时间</p>
        <p class="result-time">
          {{ getTime.hours + ":" + getTime.minutes + ":" + getTime.seconds }}
        </p>
      </div>
      <div class="current-progress">
        <p class="txt">当前进度</p>
        <el-progress :percentage="percentageNumber" :format="format"></el-progress>
      </div>
      <dsf-setting-font-size />
      <el-button class="exam-post" @click="submitPost" v-if="getAllowSubmit">提交试卷</el-button>
    </template>
  </dsf-exam-layout>
</template>

<script>
export default {
  name: "ExamPage",
  provide() {
    return {
      exam: this,
    };
  },
  data() {
    return {
      examLoading: false,
      // 是否禁用提示按钮
      codeDisabled: false,
      // 可提交按钮
      getAllowSubmit: true,
      recordId: null,
      // 试卷定时器
      examTimer: null,
      // ws读取时间
      examTiming: "",
      // 在固定时间内提交暂存
      countDown: 0,
      // 页面上显示的时间
      getTime: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      },
      // 请求获取的数据
      examInfoData: {},
      examSubject: [],
      // isReadOnly: false, // 是否只读
      // 考试进度 speed
      speedLength: 0,

      form: [],
      answeredCount: 0,
      percentageNumber: 0,
      markedCount: 0,
      examPostData: {},
      examInfoPath: "",
      showHint: "",
      WsTime: null,
      isChange: 0,
      showPopper: false,
      warningMessage: null,
      examInitTime: 0,
      useTime: 0,
      changEndTime: 0,
    };
  },
  computed: {
    isDisabled() {
      return this.confirmButtonText !== "确定" ? true : false;
    },
  },
  watch: {
    "examInfoData.items": {
      handler(val, oldVal) {
        // 标记监听
        let allSubjects = [];
        this.examInfoData.items.forEach((item) => {
          allSubjects.push(...item.questions);
        });

        this.markedCount = 0;
        _(allSubjects).forEach((item) => {
          if (item.items.value == "group") {
            _(item.children).forEach((children) => {
              this.markedCount += children.marked ? 1 : 0;
            });
          } else {
            this.markedCount += item.marked ? 1 : 0;
          }
        });
        // this.markedCount = allSubjects.filter((item) => item.marked).length;
      },
      deep: true,
    },
    form: {
      handler(val, oldVal) {
        let allSubjects = [];
        this.examInfoData.items.forEach((item) => {
          allSubjects.push(...item.questions);
        });
        // 动态监听已答题
        this.answeredCount = 0;
        _(allSubjects).forEach((item) => {
          if (item.items.value == "group") {
            _(item.children).forEach((children) => {
              this.answeredCount += children.answered ? 1 : 0;
            });
          } else {
            this.answeredCount += item.answered ? 1 : 0;
          }
        });
        // this.answeredCount = allSubjects.filter((item) => item.answered).length;
        // 计算平均值
        this.percentageNumber = this.answeredCount * (10 / this.speedLength) * 10;
      },
      deep: true,
    },
  },
  created() {
    // 获取试卷信息
    this.queryData();
  },
  mounted() {
    if (this.$route.query?.recordId) {
      this.recordId = this.$route.query.recordId;
      this.WsTime = dsf.ws();
      this.WsTime.$on("/exam/handle/time", { recordId: this.recordId }, (res) => {
        // if (res.data.type === "TIMESTAMP") {
        //   if (!this.examTiming) {
        //     this.examTiming = res.data.timeStamp;
        //   } else {
        //     if (res.data.recordId === this.recordId) {
        //       if (this.examTiming != res.data.timeStamp) {
        //         this.clearTimer();
        //         this.$router.replace({
        //           path: "error",
        //           query: {
        //             msg: "当前考试已在其它页面打开",
        //           },
        //         });
        //       }
        //     }
        //   }
        if (res.data.type === "FORCE") {
          dsf.layer.message("该次考试已强制交卷");
          this.getAllowSubmit = false;
          this.examPost();
          this.clearTimer();
          //调用提交试卷 弹窗提示一下直接提交
        } else if (res.data.type === "EXTEND") {
          //获取延长时长加到当前时长 弹窗提示一下延长？
          dsf.layer.message("该次考试已延长" + Math.ceil(res.data.addTime / 60) + "分钟");
          this.examInfoData.manageTime = this.examInfoData.manageTime + res.data.addTime;
          this.examInfoData.examTime = this.examInfoData.examTime + res.data.addTime;
          this.examInitTime = this.examInitTime + res.data.addTime;
          //延长后考试预期结束时间也要增加
          this.changEndTime = this.changEndTime + res.data.addTime * 1000
          this.warningMessage.close();
        }
      });
      this.WsTime.$send("/exam/handle/time", this.recordId, true);
    }
  },
  destroyed() {
    this.changEndTime = 0;
    this.examTiming = "";
    this.WsTime?.$destroy();
    this.clearTimer();
    window.onblur = function () {
      return false;
    };
    document.removeEventListener("visibilitychange", this.bindWindowEvent);
  },
  methods: {
    groupIndex(questions, i, j) {
      let startIndex = 1;
      for (var r = 0; r < i; r++) {
        startIndex = startIndex + questions[r].children.length;
      }
      // this.groupkey = startIndex + j
      return startIndex + j;
    },
    queryData() {
      this.examLoading = true;
      let recordId = this.$route.query?.recordId;
      this.$http
        .get("/manage/getPaperByType?id=" + recordId + "&type=" + this.$route.query?.type, {}, $$webRoot.exam)
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.examInfoData = res.data;
            this.examPostData = {
              examManageBatchId: this.examInfoData.examManageBatchId,
              examManageBatchUserRecordId: this.examInfoData.examManageBatchUserRecordId,
              paperId: this.examInfoData.examPaper.value,
            };
            let pushData = [];
            // 给多个组合题一个叠加索引 计算总题数
            let groupLen = 0;
            _.forEach(this.examInfoData.items, (item) => {
              if (item.questionsItems.value == "group") {
                let groupIndex = 0;
                _.forEach(item.questions, (questions) => {
                  _.forEach(questions.children, (child) => {
                    child.groupIndex = ++groupIndex;
                    pushData.push({
                      questionsId: child.examQuestionsId,
                      items: child.items.value,
                      property: child.questionsProperty,
                      settingId: child.settingId,
                      score: child.score,
                      treeinfoLevel: child.treeinfoLevel,
                      treeinfoPid: child.treeinfoPid,
                      results: child.result,
                    });
                  });
                });
                this.speedLength += groupIndex;
              } else {
                groupLen += Number(item.questions.length);
                // 设置默认表单提交数据
                _.forEach(item.questions, (questions) => {
                  pushData.push({
                    questionsId: questions.examQuestionsId,
                    items: questions.items.value,
                    property: questions.questionsProperty,
                    settingId: questions.settingId,
                    score: questions.score,
                    treeinfoLevel: questions.treeinfoLevel,
                    treeinfoPid: questions.treeinfoPid,
                    results: questions.result,
                  });
                });
              }
            });
            this.speedLength += groupLen;
            // 创建考试时间
            this.createExamTimer();
            // 绑定浏览器切换窗口事件
            let outNum = this.examInfoData.astrictOutNum;
            this.isChange = this.examInfoData.outNum;
            if (outNum && outNum > 0) {
              this.$nextTick(() => {
                window.onblur = () => {
                  this.blurEvent();
                };
              });
              document.addEventListener("visibilitychange", this.bindWindowEvent);
            }
            this.showHint = this.examInfoData.showHint;
            this.examInfoPath = "exam/manage/examinfo?batchId=" + this.examInfoData.examManageBatchId;
            this.form = pushData;

            this.examLoading = false;
            // 监听关闭事件
            this.initWindow();
            // this.saveExamHold();
          } else {
            dsf.layer.message(res.message, false);
            this.examLoading = false;
            if (res.state == 40085) {
              // 当前试卷已提交 取消监听事件
              this.getAllowSubmit = false;
              window.onblur = function () {
                return false;
              };
            }
          }
        })
        .catch((err) => {
          dsf.layer.message("获取试卷信息出错", false);
        });
    },
    // 考试试卷
    getExamInfo() {
      this.examLoading = true;
      return this.$http
        .get("/manage/getPaperByType?id=" + this.$route.query.recordId + "&type=" + this.$route.query.type, {}, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            return res;
          } else {
            dsf.layer.message(res.message, false);
            this.examLoading = false;
            return [];
          }
        })
        .catch((err) => {
          dsf.layer.message("获取试卷信息出错", false);
        });
    },
    //倒记时
    createExamTimer() {
      this.changEndTime = new Date().getTime() + this.examInfoData.examTime * 1000;
      this.useTime = this.examInfoData.useTime;
      this.examInitTime = this.examInfoData.examTime;
      // 添加倒计时警告提示
      this.warningMessage = ELEMENT.Message({
        type: "warning",
        duration: 0,
        offset: -160,
        visible: false,
      });
      this.examTimer = window.setInterval(() => {
        this.examInfoData.examTime--;
        let dates = this.countTime(this.examInfoData.examTime) / 1000;
        this.getTime = dsf.date.secondsToTime(dates);
        if (this.examInfoData.examTime < 30 && this.examInfoData.examTime > 1) {
          this.warningMessage.visible = true;
          this.warningMessage.verticalOffset = 10;
          this.warningMessage.message = "请注意考试时间还剩余" + this.examInfoData.examTime + "秒";
        } else if (this.examInfoData.examTime <= 0) {
          this.warningMessage.close();
          this.getAllowSubmit = false;
          this.examPost();
          this.clearTimer();
        }
      }, 1000);
    },
    countTime(seconds) {
      var time = new Date().getTime() + seconds * 1000;
      var date = new Date();
      var now = date.getTime();
      var endDate = new Date(time); //设置截止时间
      var end = endDate.getTime();
      var leftTime = end - now; //时间差

      // 10秒后自动暂存
      if (++this.countDown === 10) {
        this.saveExamHold();
      }
      // console.log("countDown", this.countDown);

      //递归每秒调用countTime方法，显示动态时间效果
      return leftTime;
    },
    clearTimer() {
      if (this.examTimer) {
        window.clearInterval(this.examTimer);
      }
    },
    // 考试答卷信息暂存接口
    saveExamHold() {
      var commitAnswerList = _.filter(this.form, function (o) {
        return !_.isNull(o.results);
      });
      let params = {
        ...this.examPostData,
        commitAnswerDtoList: commitAnswerList,
        examTiming: this.examInfoData.timeStamp,
        useTime: this.examInitTime - this.examInfoData.examTime + this.useTime,
      };
      this.$http
        .post(
          "/record/saveTemporaryPaper",
          JSON.stringify(params),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.success && res.state == 20000) {
            // this.examInfoData.examTime = res.data;
            this.countDown = 0;
            // dsf.layer.message(res.message);
          } else {
            if (res.state === 400212) {
              this.stepToRepeat();
            }
            this.countDown = 0;
            // dsf.layer.message("暂存失败！", false);
          }
        })
        .finally(() => {
          this.countDown = 0;
        });
    },
    submitPost() {
      let subTime = this.examInfoData?.manageTime - this.examInfoData?.examTime;
      if (subTime < this.examInfoData?.allowSubmitTime * 60) {
        let allowTime = dsf.date.secondsToTime(this.examInfoData?.allowSubmitTime * 60 - subTime);
        if (parseInt(allowTime.minutes) == 0 && parseInt(allowTime.seconds) > 1) {
          allowTime.minutes = 1;
        }
        dsf.layer.alert({
          title: "温馨提示",
          message: "该考试" + parseInt(allowTime.minutes) + "分钟后才能提交",
          showClose: false,
        });
      } else {
        dsf.layer
          .confirm({
            title: "温馨提示",
            message: "确认是否提交试卷？",
          })
          .then(() => {
            // 验证题目是否全部做完
            let noAnswered = [];
            _(this.examInfoData.items).forEach((data, index) => {
              _(data.questions).forEach((qs, i) => {
                if (qs.items.value == "group") {
                  _(qs.children).forEach((children) => {
                    if (!children.answered) {
                      noAnswered.push({
                        examId: children.examQuestionsId,
                        childKey: children.groupIndex,
                      });
                    }
                  });
                } else {
                  if (!qs.answered) {
                    noAnswered.push({
                      examId: qs.examQuestionsId,
                    });
                  }
                }
              });
            });
            if (noAnswered.length) {
              dsf.layer
                .confirm({
                  title: "温馨提示",
                  message: "您有" + noAnswered.length + "题未作答，确认是否提交试卷？",
                  cancelButtonText: "去看看",
                })
                .then(() => {
                  this.examPost();
                })
                .catch(() => {
                  this.toScroll(noAnswered[0].examId, noAnswered[0].childKey - 1);
                });
            } else {
              this.examPost();
            }
          })
          .catch(() => {});
      }
    },
    // 提交考试
    examPost() {
      if (this.codeDisabled) {
        return;
      }
      this.codeDisabled = true;
      this.examLoading = true;
      let params = {
        ...this.examPostData,
        commitAnswerDtoList: this.form,
        examTiming: this.examInfoData.timeStamp,
        useTime: this.examInitTime - this.examInfoData.examTime + this.useTime,
      };
      this.$http
        .post(
          "/record/commitPaper",
          JSON.stringify(params),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.success && res.state == 20000) {
            // 刷新父级
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$parentOpenerVm = window.opener.openerVms[window.name] || null;
              // 刷新首页列表
              this.$parentOpenerVm?.reloadData?.();
              this.$parentOpenerVm?.init?.();
            }
            this.$router.replace({
              path: "check-exam-status",
              query: {
                recordId: this.examInfoData.examManageBatchUserRecordId,
                manageId: this.examInfoData.examManageId,
              },
            });
            this.warningMessage.close();
          } else {
            if (res.state === 400212) {
              this.stepToRepeat();
            } else {
              dsf.layer.message(res.message, false);
            }
          }
          this.examLoading = false;
          this.codeDisabled = false;
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
          this.codeDisabled = false;
        })
        .always((res) => {
          this.examLoading = false;
        });
    },
    toScroll(examId, childKey) {
      let index = this.showPopper ? 1 : 2;
      const scrollTop = document.querySelectorAll(".ds-virtual-scroll-box")[index].scrollTop;
      let top = 0;
      if (childKey >= 0) {
        top = document.querySelectorAll("[child-refs]")[childKey].getBoundingClientRect().top;
      } else {
        top = this.$refs["question" + examId][0].getBoundingClientRect().top;
      }
      document.querySelectorAll(".ds-virtual-scroll-box")[index].scrollTo({
        top: top + scrollTop - 60, // 110
        behavior: "smooth", // 平滑滚动
      });
    },
    shwoUserInfo() {
      this.showPopper = true;
    },
    // 绑定浏览器切换窗口事件
    bindWindowEvent(e) {
      if (e.target.visibilityState === "visible") {
        this.examInfoData.examTime = parseInt((this.changEndTime - new Date().getTime()) / 1000);
      }
    },
    blurEvent() {
      this.isChange++;
      this.addOutNum();
      if (this.isChange > Number(this.examInfoData.astrictOutNum)) {
        this.isChange = 0;
        this.examPost();
      } else {
        dsf.layer.alert({
          title: "温馨提示",
          message:
            "考生跳出答卷页面次数不能超过" + this.examInfoData.astrictOutNum + "次，否则会保存并自动交卷，当前跳出次数为" + this.isChange + "次。",
          showClose: false,
        });
      }
    },
    addOutNum() {
      this.$http
        .post(
          "/record/addOutNum?recordId=" + this.examInfoData.examManageBatchUserRecordId + "&timeStamp=" + this.examInfoData.timeStamp,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (!res.success) {
            if (res.state === 400212) {
              this.stepToRepeat();
            } else {
              dsf.layer.message(res.message, false);
            }
          }
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
        });
    },
    initWindow() {
      window.onbeforeunload = function (e) {
        e = e || window.event;
        if (e) {
          e.returnValue = "确定离开当前页面吗?";
        }
        return "确定离开当前页面吗?";
      };
      if (!this.examInfoData.copyPaste) {
        document.oncontextmenu = function () {
          return false;
        };
        document.onselectstart = function () {
          return false;
        };
        document.onkeydown = function (event) {
          if (event.ctrlKey || event.altKey || event.keyCode == 123) {
            return false;
          }
        };
        document.onmousedown = function (e) {
          if (e.button == 2 || e.buttons == 2) {
            return false;
          }
        };
        document.oncopy = function () {
          return false;
        };
        document.onpaste = function () {
          return false;
        };
      }
    },
    format() {
      return this.answeredCount + "/" + this.speedLength;
    },
    //跳重复打开考试错误页面
    stepToRepeat() {
      this.$router.replace({
        path: "error",
        query: {
          msg: "当前考试已在其它页面打开",
        },
      });
    },
  },
};
</script>
